<template>
  <v-list
    two-line
    class="overflow-y-auto"
    ref="chat-list"
    style="flex: 1;"
  >
    <template v-for="(message, i) in messages">
      <v-card
        :key="'message'+i"
        :class="message.source === 'self' ? 'sent' : 'recieved'"
      >
        <v-list-item>
          <v-list-item-avatar
            v-if="message.source === 'other'"
            :color="message.avatar.color"
          >
            <span class="white--text headline">{{ message.avatar.initials }}</span>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-subtitle>{{ message.sender + ": " }}</v-list-item-subtitle>
            <v-list-item-title style="white-space: normal"> {{ message.text }}</v-list-item-title>
          </v-list-item-content>

          <v-list-item-avatar
            v-if="message.source === 'self'"
            :color="message.avatar.color"
          >
            <span class="white--text headline">{{ message.avatar.initials }}</span>
          </v-list-item-avatar>
        </v-list-item>
      </v-card>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'ChatList',

  props: {
    messages: Array
  },

  mounted () {
    setTimeout(() => {
      this.$el.scrollTop = this.scrollHeight
    }, 100)
  },

  updated () {
    if (this.scrollDistance < this.scrollHeight) {
      this.$el.scrollTop = this.scrollHeight
    }
  },

  computed: {
    scrollHeight () {
      return this.$el.scrollHeight
    },

    scrollDistance () {
      return this.$el.scrollTop
    },

    cardHeight () {
      return 0.8 * window.innerHeight
    }
  }
}
</script>
